var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"recipe-card"},on:{"click":_vm.onRecipeClick}},[_c('img',{attrs:{"src":_vm.mealImage,"alt":_vm.mealImage}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.recipe.strMeal))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eff7ea12","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecipeCard.vue
// module id = 75
// module chunks = 0